var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        click: function($event) {
          return _vm.$refs.fileinput.click()
        }
      }
    },
    [
      _c("input", {
        ref: "fileinput",
        staticClass: "d-none",
        attrs: { type: "file", accept: _vm.accept },
        on: {
          change: function($event) {
            return _vm.uploadFile($event)
          }
        }
      }),
      _vm._t(
        "button",
        [
          _vm.typeButton !== "small"
            ? _c(
                "b-button",
                {
                  staticClass: "btn",
                  attrs: { variant: "primary", disabled: _vm.progress.enabled }
                },
                [_vm._v(" " + _vm._s(_vm.text) + " ")]
              )
            : _vm._e()
        ],
        { progress: _vm.progress }
      ),
      _vm._t(
        "progress",
        [
          _vm.progress.enabled
            ? _c("vs-progress", {
                attrs: {
                  percent: _vm.progress.percent,
                  indeterminate: _vm.progress.indeterminate,
                  color: _vm.color
                }
              })
            : _vm._e()
        ],
        { progress: _vm.progress }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }